import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { environment } from '@environment';
import { ConfigService } from '../../config.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { JurisdictionalAgency } from '../../../_models';
import { IrwinIncident } from '../../../_models/incident/irwin/irwinIncident';
import { WfdssCase } from '../../../_models/incident/wfdssCase/wfdssCase';
// import { CollaboratorService } from '../../user/collaborator.service';
import { CollaboratorsFacadeService } from "src/app/_services/user/collaborators-facade.service";
import { Moment } from 'moment';


@Injectable({
  providedIn: 'root'
})
export class IrwinSearchService {
  private searchResultsSubject: BehaviorSubject<IrwinIncident[]>;
  public searchResults: Observable<IrwinIncident[]>;
  private selectedIncidentSubject: BehaviorSubject<IrwinIncident>;
  public selectedIncident: Observable<IrwinIncident>;
  private filterSubject: BehaviorSubject<string>;
  public filter: Observable<string>;
  private sortSubject: BehaviorSubject<any>;
  public sort: Observable<any>;
  private paginationSubject: BehaviorSubject<any>;
  public pagination: Observable<any>;
  private wfdssCaseSubject: BehaviorSubject<WfdssCase>;
  public wfdssCase: Observable<WfdssCase>;
  private readonly baseUrl = this.environment.irwinApi.baseUrl;
  private readonly irwinCasesByName = this.baseUrl + this.environment.irwinApi.basicSearch;
  private readonly getOrCreateCase = this.baseUrl + this.environment.irwinApi.getOrCreateWfdssCase;
  private readonly getIrwinInc = this.baseUrl + this.environment.irwinApi.incidents;
  private searchSub: Subscription;
  fireOutDate: any;

  constructor(private http: HttpClient, private collaboratorService: CollaboratorsFacadeService, private environment: ConfigService) {
    this.searchResultsSubject = new BehaviorSubject<IrwinIncident[]>([]);
    this.selectedIncidentSubject = new BehaviorSubject<IrwinIncident>(null);
    this.selectedIncident = this.selectedIncidentSubject.asObservable();
    this.searchResults = this.searchResultsSubject.asObservable();
    this.wfdssCaseSubject = new BehaviorSubject<WfdssCase>(null);
    this.wfdssCase = this.wfdssCaseSubject.asObservable();
    this.filterSubject = new BehaviorSubject<string>(null);
    this.filter = this.filterSubject.asObservable();
    this.sortSubject = new BehaviorSubject<any>(null);
    this.sort = this.sortSubject.asObservable();
    this.paginationSubject = new BehaviorSubject<any>(null);
    this.pagination = this.paginationSubject.asObservable();

  }

  search(searchString: string, offset: number = 0, limit: number = 20) {
    const url = `${this.irwinCasesByName}?offset=${offset}&limit=${limit}&search=${searchString}`;
    console.log(url);
    return this.http.get<IrwinIncident[]>(url)
      .pipe(map(irwinIncident => {
        const incidentArray = [];
        if (!!irwinIncident) {
          irwinIncident.forEach(incident => {
            const incidentObj = new IrwinIncident(incident);
            incidentArray.push(incidentObj);
          });
        }
        return incidentArray;
      }));
  }

  searchIncidents(searchString: string, offset: number = 0, limit: number = 30, increaseSet: boolean = false) {
    const url = `${this.irwinCasesByName}?offset=${offset}&limit=${limit}&search=${searchString}`;
    this.searchSub = this.http.get<IrwinIncident[]>(url)
      .subscribe(irwinIncidents => {
        let incidentArray;
        increaseSet ? incidentArray = this.searchResultsValue() : incidentArray = [];
        if (!!irwinIncidents) {
          irwinIncidents.forEach(incident => {
            const incidentObj = new IrwinIncident(incident);
            incidentArray.push(incidentObj);
          });
        }
        this.searchResultsSubject.next(incidentArray);
      });
  }

  searchResultsValue() {
    return this.searchResultsSubject.value;
  }

  getOrCreateWfdssCase(irwinId: string) {
    const url = `${this.getOrCreateCase}?irwinId=${irwinId}`;
    return this.http.get<WfdssCase>(url)
      .pipe(tap(wfdssCase => {
        if(wfdssCase.collaborators == null){
          wfdssCase.collaborators = []
        }
        this.wfdssCaseSubject.next(wfdssCase);
        return wfdssCase;
      }));
  }

  // scrubbed irwinId
  getIrwinIncident(irwinId: string, getAllFields: boolean = false) {
    irwinId = irwinId.replace('\{', '').replace('\}', '');
    const url = this.getIrwinInc + `/${irwinId}`;
    return this.http.get<IrwinIncident>(url, {params: getAllFields ? {outFields: "*"} : {}}).pipe(map(irwinIncident => {
      const createdInc = new IrwinIncident(irwinIncident);
      this.selectIncident(createdInc);
      return createdInc;
    }));
  }

  getRawFullIrwinIncident(irwinId: string, includeFinalReport: boolean = false): Observable<string> {
    irwinId = irwinId.replace('\{', '').replace('\}', '');
    const url = this.getIrwinInc + '/raw' + `/${irwinId}`;
    return this.http.get<string>(url, {
      responseType: 'text' as 'json',
      params: {
        includeFinalReport: includeFinalReport ? 'true' : 'false'
      } 
    });
  }
  
  updateWfdssCase(wfdssCase: WfdssCase) {
    this.wfdssCaseSubject.next(wfdssCase);
  }

	getWfdssCase(irwinId: string) {
		const url = `${this.getOrCreateCase}?irwinId=${irwinId}`
		this.http.get<WfdssCase>(url).pipe(
			tap((wfdssCase) => {
				this.wfdssCaseSubject.next(wfdssCase)
			}),
		)
	}

  getWfdssCaseValue() {
    return this.wfdssCaseSubject.value;
  }

  getSelectedIncidentValue() {
    return this.selectedIncidentSubject.value;
  }

  getSearchResults() {
    return this.searchResults;
  }

  selectIncident(irwinIncident: IrwinIncident) {
    this.selectedIncidentSubject.next(irwinIncident);
  }

  deselectIncident() {
    this.selectedIncidentSubject.next(null);
    this.wfdssCaseSubject.next(null);
  }

  setFilter(filter: string) {
    this.filterSubject.next(filter);
  }

  getFilter() {
    return this.filter;
  }

  setSort(sort: any) {
    this.sortSubject.next(sort);
  }

  getSort() {
    return this.sortSubject.value;
  }

  setPagination(pagination: any) {
    this.paginationSubject.next(pagination);
  }

  getPagination() {
    return this.paginationSubject.value;
  }

  // put collaborating agencies
  putJurisdictionalAgencies(wfdssCaseId: number, jurisdictionalAgencies: JurisdictionalAgency[]) {
    const url = this.environment.caseApi.baseUrl + this.environment.caseApi.cases + `/${wfdssCaseId}` + this.environment.commonUtilityApi.jurisdictionalAgencies;

    return this.http.put<JurisdictionalAgency[]>(url, jurisdictionalAgencies).pipe(map(retJurisdictionalAgencies => {
      const updatedCase = this.getWfdssCaseValue();
      updatedCase.jurisdictionalAgencies = retJurisdictionalAgencies;
      this.wfdssCaseSubject.next(updatedCase);
      return retJurisdictionalAgencies;
    }));
  }
  public get outDate(): any {
    return this.fireOutDate;
  }
  public set outDate(date: any) {
    this.fireOutDate = date;
  }

}
